module.exports = __webpack_public_path__ + "img/csm__MG_9070_f52276ae99.2cc36c55.jpg";